export const patientRows = [
  {
    id: 1,
    pname: 'James Hunt',
    dob: '03/06/2006 (20 yrs)',
    sex: 'Male',
    lastVisit: '06/09/2026'
  },
  {
    id: 2,
    pname: 'Philip, Cammee John',
    dob: '03/06/2006 (20 yrs)',
    sex: 'Female',
    lastVisit: '06/09/2026'
  },
  {
    id: 3,
    pname: 'Alice Johnson',
    dob: '11/12/1998 (27 yrs)',
    sex: 'Female',
    lastVisit: '06/10/2026'
  },
  {
    id: 4,
    pname: 'Michael Brown',
    dob: '08/15/1989 (36 yrs)',
    sex: 'Male',
    lastVisit: '06/11/2026'
  },
  {
    id: 5,
    pname: 'Sophia Williams',
    dob: '02/18/1994 (32 yrs)',
    sex: 'Female',
    lastVisit: '06/12/2026'
  },
  {
    id: 6,
    pname: 'David Miller',
    dob: '05/09/1978 (48 yrs)',
    sex: 'Male',
    lastVisit: '06/13/2026'
  },
  {
    id: 7,
    pname: 'Emma Davis',
    dob: '09/25/2001 (25 yrs)',
    sex: 'Female',
    lastVisit: '06/14/2026'
  },
  {
    id: 8,
    pname: 'William Anderson',
    dob: '01/30/1986 (40 yrs)',
    sex: 'Male',
    lastVisit: '06/15/2026'
  },
  {
    id: 9,
    pname: 'Olivia Martinez',
    dob: '12/14/1992 (33 yrs)',
    sex: 'Female',
    lastVisit: '06/16/2026'
  },
  {
    id: 10,
    pname: 'Daniel Thomas',
    dob: '07/08/1984 (42 yrs)',
    sex: 'Male',
    lastVisit: '06/17/2026'
  },
  {
    id: 11,
    pname: 'Charlotte Moore',
    dob: '10/05/1999 (26 yrs)',
    sex: 'Female',
    lastVisit: '06/18/2026'
  },
  {
    id: 12,
    pname: 'Benjamin Taylor',
    dob: '06/16/1987 (39 yrs)',
    sex: 'Male',
    lastVisit: '06/19/2026'
  },
  {
    id: 13,
    pname: 'Amelia Jackson',
    dob: '03/22/1995 (31 yrs)',
    sex: 'Female',
    lastVisit: '06/20/2026'
  },
  {
    id: 14,
    pname: 'Matthew White',
    dob: '11/10/1981 (45 yrs)',
    sex: 'Male',
    lastVisit: '06/21/2026'
  },
  {
    id: 15,
    pname: 'Mia Harris',
    dob: '05/17/2000 (26 yrs)',
    sex: 'Female',
    lastVisit: '06/22/2026'
  },
  {
    id: 16,
    pname: 'Christopher Martin',
    dob: '02/03/1979 (47 yrs)',
    sex: 'Male',
    lastVisit: '06/23/2026'
  },
  {
    id: 17,
    pname: 'Harper Thompson',
    dob: '09/27/1996 (30 yrs)',
    sex: 'Female',
    lastVisit: '06/24/2026'
  },
  {
    id: 18,
    pname: 'Joseph Garcia',
    dob: '04/19/1985 (41 yrs)',
    sex: 'Male',
    lastVisit: '06/25/2026'
  },
  {
    id: 19,
    pname: 'Evelyn Martinez',
    dob: '08/02/1993 (33 yrs)',
    sex: 'Female',
    lastVisit: '06/26/2026'
  },
  {
    id: 20,
    pname: 'Andrew Robinson',
    dob: '12/28/1982 (44 yrs)',
    sex: 'Male',
    lastVisit: '06/27/2026'
  },
  {
    id: 21,
    pname: 'Abigail Clark',
    dob: '01/07/1997 (29 yrs)',
    sex: 'Female',
    lastVisit: '06/28/2026'
  },
  {
    id: 22,
    pname: 'Joshua Rodriguez',
    dob: '07/14/1988 (38 yrs)',
    sex: 'Male',
    lastVisit: '06/29/2026'
  },
  {
    id: 23,
    pname: 'Ella Lewis',
    dob: '10/20/1991 (35 yrs)',
    sex: 'Female',
    lastVisit: '06/30/2026'
  },
  {
    id: 24,
    pname: 'Ryan Lee',
    dob: '03/11/1983 (43 yrs)',
    sex: 'Male',
    lastVisit: '07/01/2026'
  },
  {
    id: 25,
    pname: 'Grace Walker',
    dob: '06/24/1998 (28 yrs)',
    sex: 'Female',
    lastVisit: '07/02/2026'
  },
  {
    id: 26,
    pname: 'Nathan Hall',
    dob: '05/04/1980 (46 yrs)',
    sex: 'Male',
    lastVisit: '07/03/2026'
  },
  {
    id: 27,
    pname: 'Lily Allen',
    dob: '09/09/1994 (32 yrs)',
    sex: 'Female',
    lastVisit: '07/04/2026'
  },
  {
    id: 28,
    pname: 'Anthony Young',
    dob: '02/13/1986 (40 yrs)',
    sex: 'Male',
    lastVisit: '07/05/2026'
  },
  {
    id: 29,
    pname: 'Scarlett King',
    dob: '04/26/1990 (36 yrs)',
    sex: 'Female',
    lastVisit: '07/06/2026'
  },
  {
    id: 30,
    pname: 'Jonathan Scott',
    dob: '11/18/1987 (39 yrs)',
    sex: 'Male',
    lastVisit: '07/07/2026'
  }
];
export const clinicOptions = [
  {
    value: 'clinic',
    label: 'EL Camino Medical Clinic, 6510 Lon...'
  },
  {
    value: 'chicago',
    label: 'Chicago'
  },
  {
    value: 'new-york',
    label: 'New York'
  }
];